import { z } from 'zod';

/** SQS message body for device-attestation-compiler Lambda. */
export const deviceAttestationCompilerQueueMessageSchema = z.object({
  tenantId: z.string().trim().min(1),
  reason: z.string().trim().min(1).optional(),
  serialNumber: z.string().trim().min(1).optional(),
  requestedAt: z.string().datetime().optional(),
});
// Inferred types
export type DeviceAttestationCompilerQueueMessage = z.infer<typeof deviceAttestationCompilerQueueMessageSchema>;
